<template>
  <div class="row text-center" v-if="List && List.length>0">
    <div class="mt-4 mb-4 col-12 text-center">
      <!-- <button type="button" :disabled="DefPage <= 0" class="btn btn-secondary mr-1" dir="ltr" @click="Back()"> -->
      <span :class="DefPage <= 0 ? '' : 'Pointer'" @click="DefPage <= 0 ? '' : FirstPage()" data-title="صفحــه اول" class="badge badge-PageNation text-light"><i class="fad fa-chevron-double-right m-1 text-light"></i></span>
      <span :class="DefPage <= 0 ? '' : 'Pointer'" class="badge badge-PageNation mr-1 text-light" dir="ltr" @click="DefPage <= 0 ? '' : Back()" data-toggle="tooltip" data-placement="left" data-title="صفحه قبلی">
        <i class="fad fa-arrow-right m-1 text-light"></i>
      </span>
      <!-- </button> -->
      <span class="mx-2">
        صفحه <span class="badge text-warning">{{ DefPage + 1 }}</span> - {{ AllPage }}
      </span>
      <!-- <button type="button" :disabled="DefPage >= AllPage - 1" class="btn btn-secondary mr-1" dir="ltr" @click="Next()"> -->
        <span :class="DefPage >= AllPage - 1 ? '' : 'Pointer'" class="badge badge-PageNation ml-1" dir="ltr" @click="DefPage >= AllPage - 1 ? '' : Next()" data-toggle="tooltip" data-placement="left" data-title="صفحه بعدی">
          <i class="fad fa-arrow-left m-1"></i>
        </span>
        <span :class="DefPage >= AllPage - 1 ? '' : 'Pointer'" data-title="صفحــه آخر" class="badge badge-PageNation text-light" @click="DefPage >= AllPage - 1 ? '' : LastPage()"><i class="fad fa-chevron-double-left m-1 text-light"></i></span>
      <!-- </button> -->
      
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ListCopy: [],
      AllPage: 0,
      DefPage: 0,
      ListResult: [],
    }
  },
  props: ['List', 'CountOfPage'],
  methods: {
    GetPageNation() {
      this.AllPage = Math.ceil(this.List.length / this.CountOfPage)
      this.ListResult = this.List.slice(0, this.DefPage * this.CountOfPage + this.CountOfPage)
      this.$emit('ListResult', this.ListResult)
    },
    Next() {
      this.DefPage++
      this.ListResult = this.ListCopy.slice(this.DefPage * this.CountOfPage, this.DefPage * this.CountOfPage + this.CountOfPage)
      this.$emit('ListResult', this.ListResult)
    },
    Back() {
      this.DefPage--
      this.ListResult = this.ListCopy.slice(this.DefPage * this.CountOfPage, this.DefPage * this.CountOfPage + this.CountOfPage)
      this.$emit('ListResult', this.ListResult)
    },
  },
  created() {
    for (let index = 0; index < this.List.length; index++) {
      this.List[index]['rowNumber'] = index + 1
    }
    this.ListCopy = JSON.parse(JSON.stringify(this.List))
    this.GetPageNation()
  },
}
</script>
<style scoped>
.badge-PageNation {
  border: 1px solid rgb(136, 136, 136);
}
</style>
